import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';
import ClearSearchIcon from './search_clear_icon.svg';

const SearchField = ({
  value,
  performSearch
}) => (
  <div className={styles.searchContainer}>
    <form role="search" autoComplete="off">
      <div className={`form-group search-control ${styles.searchInput}`}>
        <input
          type="text"
          className="search-input form-control"
          placeholder="Search for your technology..."
          tabIndex={0}
          value={value}
          onChange={e => performSearch(e.target.value)}
        />
        {value && <a role="button" className={styles.clearSearch} onClick={() => performSearch('')} tabIndex={0}><ClearSearchIcon /></a>}
      </div>
    </form>
  </div>
);

SearchField.propTypes = {
  value: PropTypes.string,
  performSearch: PropTypes.func
};

export default SearchField;
